/** MODAL POSTS PERFIL*/

import styled from "styled-components";

export const ModalPostsStyled = styled.div`
	.cards {
		overflow: scroll;
		max-height: 80vh;
		padding: 1rem;
	}
`;
